import React from 'react'

function ServerError () {
    return <></>
}

export default ServerError